<my-footer>
    <footer class="px-8 mt-5">
        <div class="py-12 md:flex md:items-center md:justify-between">
            <div class="flex justify-center gap-x-6 md:order-2">
                <span class="mt-8 text-center text-sm/6 text-gray-500">Version { VERSION }</span>
            </div>
            <p class="mt-8 text-center text-sm/6 text-gray-600 md:order-1 md:mt-0">&copy; 2025 <a href="https://www.originiagency.it" target="_blank">Origini srls</a>, Inc. All rights reserved.</p>
        </div>
    </footer>

    <script>
        import { VERSION } from '/src/utils/constants'

        export default {
            VERSION
        }
    </script>

</my-footer>
